export default __webpack_public_path__ + "static/media/eye-icon.ffd9fe02.svg";